import React, { useEffect, createRef, useRef } from 'react'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { cn } from '~/utils/cn'

import './index.scss'

export default function OneTimeCodeInput({
    code = '',
    isRecoveryCode = false,
    onChange = () => {},
    onEnter = () => {}
}) {
    const inputCount = isRecoveryCode ? 8 : 6
    const chars = code.split('')
    const refs = useRef([])

    useEffect(() => {
        refs.current = Array(inputCount)
            .fill()
            .map((_, i) => refs.current[i] || createRef())
        // Focus first  on mode change
        refs.current[0]?.current?.focus()
    }, [inputCount])

    const updateVal = (e) => {
        const arr = code.split('')
        const index = parseInt(e.target.name)
        let val = e.target.value
        if (val.length > 1) {
            val = val[0]
        }
        arr[index] = val
        onChange(arr.join(''))
        if (val) {
            if (index < inputCount - 1) {
                const nextInput = refs.current[index + 1]
                nextInput?.current?.focus()
                nextInput?.current?.select()
            }
        }
    }

    const pasted = (e) => {
        e.preventDefault()
        const val = e.clipboardData.getData('text')
        if (val.length === inputCount && parseInt(val) > 0) {
            onEnter(val)
        }
    }

    const onKeyDown = (e) => {
        const index = parseInt(e.target.name)
        if (e.key === 'Enter') {
            onEnter()
        }
        if (e.key === 'Backspace') {
            if (index > 0) {
                const prevInput = refs.current[index - 1]
                prevInput?.current?.focus()
                prevInput?.current?.select()
            }
        }
        if (e.key === 'ArrowLeft') {
            if (index > 0) {
                const prevInput = refs.current[index - 1]
                prevInput?.current?.focus()
                prevInput?.current?.select()
            }
        }
        if (e.key === 'ArrowRight') {
            if (index < inputCount - 1) {
                const nextInput = refs.current[index + 1]
                nextInput?.current?.focus()
                nextInput?.current?.select()
            }
        }
    }

    return (
        <div className={cn('one-time-code-input', isRecoveryCode && 'one-time-code-input--recovery')}>
            {Array.from({ length: inputCount }).map((_, i) => (
                <TextInput
                    key={i}
                    maxLength='1'
                    inputRef={refs.current[i]}
                    type='text'
                    name={i}
                    value={chars[i] || ''}
                    onPaste={pasted}
                    onChange={updateVal}
                    onKeyDown={onKeyDown}
                    onFocus={(e) => e.target.select()}
                    className='hideNumberOptions'
                    autoComplete='one-time-code'
                />
            ))}
        </div>
    )
}
